'use client'

import React, { useState, type ReactNode } from 'react'

interface CollapseItemProps {
  title?: string
  children?: ReactNode
  active?: boolean
  isCollapsible?: boolean
}

export default function CollapseItem({
  title,
  children,
  active = false,
  isCollapsible = true,
}: CollapseItemProps) {
  const [isOpen, setIsOpen] = useState(active)
  return (
    <div className="dark:bg-body-dark border-neutral-200 bg-white dark:border-neutral-600 md:rounded-[12px]">
      <button
        className="dark:bg-body-dark [&:not([data-twe-collapse-collapsed])]:text-primary [&:not([data-twe-collapse-collapsed])]:shadow-border-b dark:[&:not([data-twe-collapse-collapsed])]:bg-surface-dark dark:[&:not([data-twe-collapse-collapsed])]:text-primary group relative flex w-full items-center rounded-t-lg border-0 bg-white p-4 text-left text-base text-neutral-800 transition [overflow-anchor:none] hover:z-[2] focus:z-[3] focus:outline-none dark:text-white sm:hidden [&:not([data-twe-collapse-collapsed])]:bg-white dark:[&:not([data-twe-collapse-collapsed])]:shadow-white/10"
        type="button"
        onClick={() => setIsOpen(!isOpen)}
      >
        <h3 className="font-lora text-[16px] font-medium leading-[24px] text-[#2D2E32] sm:text-[20px]">
          {title}
        </h3>
        {isOpen ? (
          <span className="-me-1 ms-auto h-4 w-4 shrink-0 transition-transform duration-200 ease-in-out group-data-[twe-collapse-collapsed]:me-0 group-data-[twe-collapse-collapsed]:rotate-0 motion-reduce:transition-none [&>svg]:h-4 [&>svg]:w-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="#896145"
            >
              <path d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
            </svg>
          </span>
        ) : (
          <span className="-me-1 ms-auto h-4 w-4 shrink-0 rotate-[-180deg] transition-transform duration-200 ease-in-out group-data-[twe-collapse-collapsed]:me-0 group-data-[twe-collapse-collapsed]:rotate-0 motion-reduce:transition-none [&>svg]:h-4 [&>svg]:w-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="#896145"
            >
              <path d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
            </svg>
          </span>
        )}
      </button>
      <h3 className="hidden p-4 font-lora text-[24px] font-semibold text-secondary-950 sm:block">
        {title}
      </h3>

      <div
        id="collapseOne"
        className="!visible"
        data-twe-collapse-item
        data-twe-collapse-show
        aria-labelledby="headingOne"
        data-twe-parent="#accordionExample"
      >
        {isOpen && <div className="grid gap-4 px-4 pb-4">{children}</div>}
      </div>
    </div>
  )
}
